<svelte:options />

<script>
    /**
     * @typedef {Object} Props
     * @property {string} [placeholder]
     * @property {any} name
     * @property {any} value
     * @property {boolean} [required]
     * @property {any} associatedID
     * @property {number} [maxChars]
     */
    let {
        placeholder = '',
        name,
        value = $bindable(),
        required = false,
        associatedID = null,
        onKeyUp = () => {},
        onchange = () => {},
        maxChars = null,
        disabled = false,
    } = $props();

    let editorDOM = $state(null);
    const charCount = $derived(value ? value.length : 0);

    function handleChange(e) {
        let text = e.target.value;
        if (maxChars !== null && text.length > maxChars) {
            text = text.slice(0, maxChars);
            e.target.value = text;
        }
        value = text;

        onchange({
            detail: {
                originalEvent: e,
                name,
                value,
                required,
                associatedID,
            }
        });
    }

    // Expose editorDOM for testing
    export function getEditorDOM() {
        return editorDOM;
    }

    export {
        placeholder,
        name,
        value,
        required,
        associatedID,
        maxChars,
    };
</script>

<div class="text-input">
    <textarea
        bind:this={editorDOM}
        class="textarea"
        onchange={handleChange}
        onkeyup={(e) => {
            onKeyUp(e);
        }}
        {name}
        {required}
        {disabled}
        {placeholder}
        rows="5"
        {maxChars}
        maxlength={maxChars}
        bind:value
    >
    </textarea>
    
    {#if maxChars !== null}
        <div class="char-counter">
            Max {maxChars} characters, {charCount} used
        </div>
    {/if}
</div>

<style>
    .text-input {
        display: flex;
        flex-direction: column;
        flex-grow: 10;
        width: 100%;
        max-width: 24rem;
        min-height: 12rem;
        position: relative;
    }

    .textarea {
        padding: 0.75rem;
        background-color: rgba(0, 0, 0, 0.6);
        color: #eee;
        border-radius: 0.35rem;
        border: solid 1px rgba(0, 0, 0, 0.1);
        width: 100%;
        resize: none;
        box-sizing: border-box;
    }

    .textarea:focus {
        background-color: rgba(0, 0, 0, 0.5);
        outline: 1px solid rgb(74, 198, 255);
        color: #eee;
    }

    .char-counter {
        align-self: flex-end;
        font-size: 0.85rem;
        color: #aaa;
        margin-top: 0.25rem;
        margin-right: 0.5rem;
        margin-bottom: 0.25rem;
    }
</style>
